import { NOLA_PHONE, locationSchema } from "../structured-data-core";

export function getKansasCityStructuredData() {
  const url = "https://restorehair.com/locations/missouri/kansas-city/";
  const description =
    "Find out about your hair transplant options in Kansas City with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Kansas City", "2300 Main Street, Suite 900", "Kansas City", "MO", NOLA_PHONE, url, description),
  ];
}
